import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import PasswordUpdate from '../../components/PasswordUpdate'

const UserPassword = () => {
    return (
        <UserLayout>
            <PasswordUpdate />
        </UserLayout>
    )
}

export default UserPassword
